
import { Vue, Options } from 'vue-class-component';
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus';
import IMUserService from '@/services/imUserService';
import CreateIMUserModel from '@/models/imusers/createIMUserModel';
import CurrentUserService from '@/services/currentUserService';
import AccountType from '@/constants/AccountType';
import * as countryAreaCode from '@/assets/data/countryAreaCode.json';
import * as genderCode from '@/assets/data/genderCode.json';
import * as statusCode from '@/assets/data/statusCode.json';
import router from '@/router';
import ErrorCode from '@/constants/ErrorCode';
import CommonValidate from '@/services/commonValidate';
import Application from '@/models/applications/application';

export default class IMUser extends Vue {
    private application: Application = {};

    private statusCodes = (statusCode as any).default;

    private countryAreaCodes = (countryAreaCode as any).default;

    private genderCodes = (genderCode as any).default;

    private isCreate = false;

    private userList = [];

    private dialogVisible = false;

    private status = -1;

    private name = '';

    private page = 1;

    private size = 10;

    private total = 0;

    private createModel = new CreateIMUserModel();

    private appId = '';

    private rules = {
        name: [
            {
                required: true,
                whitespace: true,
                message: '请输入用户名',
                trigger: 'blur',
            },
            { validator: CommonValidate.validateUserName, trigger: 'blur' },
        ],
        code: [
            {
                required: true,
                whitespace: true,
                message: '请输入用户编码',
                trigger: 'blur',
            },
            { validator: CommonValidate.validateCode, trigger: 'blur' },
        ],
        phoneNo: [
            {
                required: true,
                whitespace: true,
                message: '请输入手机号码',
                trigger: 'blur',
            },
            { validator: CommonValidate.validatePhone, trigger: 'blur' },
        ],
        userAccount: [
            {
                required: true,
                whitespace: true,
                message: '请输入用户账号',
                trigger: 'blur',
            },
            { validator: CommonValidate.validateAccount, trigger: 'blur' },
        ],
    };

    mounted(): void {
        this.isCreate =
            CurrentUserService.userInfo.accountType ===
                AccountType.CustomerAccount ||
            CurrentUserService.userInfo.accountType ===
                AccountType.CustomerSubAccount;
        this.appId = this.$route.params.appId as string;
        this.loadData();
    }

    closeDialog(): void {
        const form: any = this.$refs.createform;
        form.resetFields();
        this.dialogVisible = false;
    }

    loadData(): void {
        IMUserService.getAll(
            this.page,
            this.size,
            this.status,
            this.appId,
            this.name
        )
            .then((result) => {
                if (result.code === ErrorCode.Success) {
                    this.userList = result.data.data;
                    this.total = result.data.total;
                }
            })
            .catch((err) => {
                if (err && err !== '取消重复请求') {
                    ElMessage.error(err);
                    console.error(err);
                }
            });
    }

    pageChange(currentPage: number): void {
        this.page = currentPage;
        this.loadData();
    }

    edit(id: string): void {
        router.push({ path: `imuser/${id}` });
    }

    reSetPass(id: string): void {
        ElMessageBox.confirm('你确定要重置当前用户的密码?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            IMUserService.reSetPassword(id, this.appId)
                .then((response) => {
                    if (response.code === ErrorCode.Success) {
                        ElMessage.success(response.msg);
                        this.loadData();
                    } else {
                        ElMessage.error(response.msg);
                    }
                })
                .catch((response) => {
                    ElMessage.error(response.msg);
                });
        });
    }

    del(id: string, name: string): void {
        const msg = `你确定要删除用户【${name}】吗?`;
        ElMessageBox.confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(() => {
            IMUserService.delete(id, this.appId)
                .then((response) => {
                    if (response.code === ErrorCode.Success) {
                        ElMessage.success('删除成功!');
                        this.loadData();
                    } else {
                        ElMessage.error(response.msg);
                    }
                })
                .catch((response) => {
                    ElMessage.error(response.msg);
                });
        });
    }

    save(): void {
        const form: any = this.$refs.createform;
        form.validate((valid: boolean) => {
            if (valid) {
                const loadingInstance = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                IMUserService.create(this.createModel, this.appId)
                    .then((response) => {
                        loadingInstance.close();
                        if (response.code === ErrorCode.Success) {
                            ElMessage.success(response.msg);
                            this.loadData();
                            this.dialogVisible = false;
                            form.resetFields();
                        } else {
                            ElMessage.error(response.msg);
                        }
                    })
                    .catch((err) => {
                        loadingInstance.close();
                        console.error(err);
                        ElMessage.error(err);
                    });
            }
        });
    }
}
